<template>
  <el-dialog
    :title="$t('dialog.titleSelectionPackageAndPackageGroup')"
    :visible="isShow"
    :close-on-click-modal="false"
    append-to-body
    width="1200px"
    @close="onClose"
  >
    <div>
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row align-end">
              <div class="das-form-col col-3">
                <div class="das-form-input">
                  <div class="label">
                    {{ $t('field.packageGroupPackageCodeOrName') }}
                  </div>
                  <input v-model="searchParams.keyword" type="text" />
                </div>
              </div>
              <div class="das-form-col col-3">
                <div class="das-form-input">
                  <div class="label">
                    {{ $t('field.saleDate') }}
                  </div>
                  <SingleCalendar
                    v-model="searchParams.saleDate"
                    class="use-icon"
                  />
                </div>
              </div>
              <div class="das-form-col">
                <button class="btn primary small" @click="fnSearchPackage">
                  {{ $t('button.search') }}
                </button>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form col">
                <div class="checkbox-wrap">
                  <input
                    id="isExpDate"
                    v-model="searchParams.isExpDate"
                    type="checkbox"
                  />
                  <label for="isExpDate">
                    {{ $t('field.showExpiredPackage') }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>

      <div>
        <el-row type="flex" align="center" justify="between">
          <el-col :span="11" class="grid-container">
            <div class="grid-title">
              {{
                $t('views.configuration.unselectedPackageAndGroupPackageList')
              }}
            </div>
            <hr />
            <div style="height: 500px">
              <GridEnterprise
                ref="gridNotAttached"
                dom-layout="normal"
                :columns="packageCols"
                :get-row-height="getRowHeight"
                :rows="notAttachedPackageRows"
                :get-data-path="getDataPath"
                :default-col-def="defaultColDef"
                :auto-group-column-def="autoGroupColumnDef"
                :tree-data="true"
                :group-grid="true"
                :group-default-expanded="groupDefaultExpanded"
                :group-selects-children="false"
                :group-use-entire-row="false"
                :is-row-selectable="isRowSelectable"
                group-field="path"
                row-selection="multiple"
                class="agGrid"
                @selectionChanged="onSelectPackRow"
              />
            </div>
          </el-col>
          <el-col :span="2" class="flex-col justify-center">
            <el-row type="flex" justify="center">
              <button
                class="btn only-icon transfer"
                style="margin-bottom: 10px"
                @click="fnAttachPackage"
              >
                <i class="el-icon-d-arrow-right"></i>
              </button>
            </el-row>
            <el-row type="flex" justify="center">
              <button
                class="btn only-icon transfer"
                style="margin-bottom: 10px"
                @click="fnDeattachPackage"
              >
                <i class="el-icon-d-arrow-left"></i>
              </button>
            </el-row>
          </el-col>
          <el-col :span="11" class="grid-container">
            <div class="grid-title">
              {{ $t('views.configuration.selectedPackageAndGroupPackageList') }}
            </div>
            <hr />
            <div style="height: 500px">
              <GridEnterprise
                ref="gridAttached"
                dom-layout="normal"
                :columns="packageCols"
                :rows="attachedPackageRows"
                :get-row-height="getRowHeight"
                :get-data-path="getDataPath"
                :default-col-def="defaultColDef"
                :auto-group-column-def="autoGroupColumnDef"
                :tree-data="true"
                :group-grid="true"
                :group-default-expanded="groupDefaultExpanded"
                :group-selects-children="false"
                :group-use-entire-row="false"
                group-field="path"
                row-selection="multiple"
                class="agGrid"
                @selectionChanged="onSelectPackRowAttached"
              />
              <!-- <ag-grid-vue
                id="grid-2"
                style="width: 100%; height: 100%"
                class="ag-theme-alpine"
                :grid-options="gridOptions"
                :row-data="attachedPackageRows"
                :column-defs="packageCols"
                :default-col-def="defaultColDef"
                :auto-group-column-def="autoGroupColumnDef"
                :tree-data="true"
                :animate-rows="true"
                :modules="modules"
                :get-data-path="getDataPath"
                :group-default-expanded="groupDefaultExpanded"
                :group-selects-children="true"
                row-selection="multiple"
              /> -->
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <div class="button-containers flex justify-end" style="gap: 10px">
        <button class="btn primary small outline" @click="onClose">
          {{ $t('button.cancel') }}
        </button>
        <button class="btn primary small" @click="fnSave">
          {{ $t('button.save') }}
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import SingleCalendar from '@/components/ui/SingleCalendar.vue'
import { AgGridVue } from '@ag-grid-community/vue'
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model'
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping'
import {
  getPackageListApi,
  // eslint-disable-next-line no-unused-vars
  getPackageSelectedListApi
} from '@/api/Service_Policy/priceCode'
// eslint-disable-next-line no-unused-vars
import { getPackageApi } from '@/api/Service_Policy/package'
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    'ag-grid-vue': AgGridVue,
    SingleCalendar
  },
  props: {
    priceCodeId: {
      type: [String, Number],
      default: null
    },
    packageGroupAttached: {
      type: Array,
      default: () => []
    },
    packageAttached: {
      type: Array,
      default: () => []
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // GRID
      gridNotAttachedApi: null,
      gridAttachedApi: null,
      gridColumnApi: null,
      gridOptions: {},
      // columnDefs: {},
      defaultColDef: null,
      autoGroupColumnDef: null,
      getRowHeight: params => 70,
      modules: [ClientSideRowModelModule, RowGroupingModule],
      notAttachedPackageRows: [],
      packageCols: [
        {
          headerName: this.$t('grid.column.packageNameOrPackageGroupName'),
          field: 'package_nm',
          // cellClass: 'grid-cell-centered',
          minWidth: 100
        }
      ],
      attachedPackageRows: [],
      attachedPackageRowsPrevious: [], // For reset the previous state of attached rows
      searchParams: {
        keyword: '',
        saleDate: null,
        isExpDate: false,
        priceCodeId: null
      }
    }
  },
  watch: {
    packageAttached: {
      deep: true,
      handler(val) {}
    },
    packageGroupAttached: {
      deep: true,
      handler(val) {}
    },
    priceCodeId: {
      immediate: true,
      handler(val) {
        // this.searchParams.priceCodeId = val
      }
    },

    isShow: {
      handler(val) {
        if (val) {
          this.attachPackageData()
        } else {
          // Reset 2 tables' rows and previousAttached data
          this.notAttachedPackageRows = []
          this.attachedPackageRows = []
          this.attachedPackageRowsPrevious = []

          this.searchParams = {
            keyword: '',
            saleDate: null,
            isExpDate: false,
            priceCodeId: null
          }
        }
      }
    }
  },
  mounted() {
    this.gridAttachedApi = this.$refs.gridAttached?.gridApi
    this.gridNotAttachedApi = this.$refs.gridNotAttached?.gridApi

    // this.fnGetPackageList()
  },
  beforeMount() {
    this.fnPrepareGrid()
  },
  updated() {
    this.gridAttachedApi = this.$refs.gridAttached?.gridApi
    this.gridNotAttachedApi = this.$refs.gridNotAttached?.gridApi
  },
  methods: {
    onClose() {
      this.$emit('close')
    },

    fnGetFlatRowArray(arr) {
      const flatArr = arr.flatMap(item => {
        // path - unique, for dividing data intro tree data
        const path = item.is_package_group
          ? `${item.package_id}-group`
          : `${item.package_id}`

        const packageObject = {
          path: [path],
          package_id: item.package_id,
          package_code: item.package_code,
          package_nm: item.package_nm,
          // price_code_id: item.price_code_id,
          // price_code_nm: item.price_code_nm,
          is_package_group: item.is_package_group
        }

        // package not in package_group
        if (!item.is_package_group) {
          return [packageObject]
        }

        // package_group
        return [
          packageObject,
          ...item.package?.map(child => ({
            path: [path, child.package_id],
            package_code: child.package_code,
            package_id: child.package_id,
            package_nm: child.package_nm,
            code: child.package_code,
            p_id: item.package_id
          }))
        ]
      })

      return flatArr
    },
    fnSave() {
      const package_group_list = []
      const package_list = []
      this.attachedPackageRows.forEach(item => {
        if (item.is_package_group) package_group_list.push(item)
        else if (!item.p_id) package_list.push(item)
      })
      this.$emit('selectPackages', {
        package_group: package_group_list,
        package: package_list
      })
      this.$emit('close')
    },

    /** Attach data - v1 */
    async fnGetPackageList() {
      const data = await getPackageListApi(this.searchParams)

      const packageAttachedArr = []
      const packageNotAttachedArr = []

      // packageAttachedIds - packageGroupAttachedIds: Arrays (map from props' arrays) -> For checking if package is attached or not
      const packageAttachedIds = this.packageAttached.map(
        item => item.package_id
      )
      const packageGroupAttachedIds = this.packageGroupAttached.map(
        item => item.package_id
      )

      data.data.forEach(item => {
        if (
          (item.is_package_group &&
            packageGroupAttachedIds.includes(item.package_id)) ||
          (!item.is_package_group &&
            packageAttachedIds.includes(item.package_id))
        ) {
          packageAttachedArr.push(item)
        } else {
          packageNotAttachedArr.push(item)
        }
      })
      this.notAttachedPackageRows = this.fnGetFlatRowArray(
        packageNotAttachedArr
      )
      this.attachedPackageRows = this.fnGetFlatRowArray(packageAttachedArr)
      this.attachedPackageRowsPrevious = [...this.attachedPackageRows]
    },

    /** Attach data - v2 */
    async attachPackageData() {
      await Promise.all([
        this.attachUnselectedPackageList(),
        this.attachSelectedPackageList()
      ])
    },
    async attachUnselectedPackageList() {
      const searchParams = {
        ...this.searchParams,
        priceCodeId: this.priceCodeId
      }
      getPackageListApi(searchParams)
        .then(res => {
          const packageNotAttachedArr = []
          const packageAttachedIds = this.packageAttached.map(
            item => item.package_id
          )
          const packageGroupAttachedIds = this.packageGroupAttached.map(
            item => item.package_id
          )

          res.data.forEach(item => {
            if (
              (item.is_package_group &&
                !packageGroupAttachedIds.includes(item.package_id)) ||
              (!item.is_package_group &&
                !packageAttachedIds.includes(item.package_id))
            ) {
              packageNotAttachedArr.push(item)
            }
          })

          this.notAttachedPackageRows = this.fnGetFlatRowArray(
            packageNotAttachedArr
          )
        })
        .catch(err => {
          console.log(err)
        })
    },

    async attachSelectedPackageList() {
      // getPackageSelectedListApi({ priceCodeId: this.priceCodeId })
      //   .then(res => {
      //     this.attachedPackageRows = this.fnGetFlatRowArray(res.data)
      //     this.attachedPackageRowsPrevious = [...this.attachedPackageRows]
      //   })
      //   .catch(err => {
      //     console.log(err)
      //   })

      /**
       * 1. Get all package
       * 2. Filter attached (selected) package
       */
      await getPackageListApi({ isExpDate: true })
        .then(res => {
          const packageAttachedArr = []

          const packageAttachedIds = this.packageAttached.map(
            item => item.package_id
          )
          const packageGroupAttachedIds = this.packageGroupAttached.map(
            item => item.package_id
          )

          res.data.forEach(item => {
            if (
              (item.is_package_group &&
                packageGroupAttachedIds.includes(item.package_id)) ||
              (!item.is_package_group &&
                packageAttachedIds.includes(item.package_id))
            ) {
              packageAttachedArr.push(item)
            }
          })
          this.attachedPackageRows = this.fnGetFlatRowArray(packageAttachedArr)
        })
        .catch(err => {
          console.log(err)
        })
    },

    onSelectPackRow(rows) {
      // const nodeSelected = this.gridNotAttachedApi.getSelectedNodes()
      // const nodeSelectedIds = nodeSelected.map((node) => node.id)
      this.gridNotAttachedApi.forEachNode(node => {
        if (node.childrenAfterGroup.length > 0) {
          if (node.isSelected()) {
            node.childrenAfterGroup.forEach(childNode => {
              childNode.setSelected(true)
            })
          } else {
            node.childrenAfterGroup.forEach(childNode => {
              childNode.setSelected(false)
            })
          }
        }
      })
    },
    onSelectPackRowAttached(rows) {
      this.gridAttachedApi.forEachNode(node => {
        if (node.childrenAfterGroup.length > 0) {
          if (node.isSelected()) {
            node.childrenAfterGroup.forEach(childNode => {
              childNode.setSelected(true)
            })
          } else {
            node.childrenAfterGroup.forEach(childNode => {
              childNode.setSelected(false)
            })
          }
        }
      })
    },

    /** fnSearchPackage-v1 */
    // async fnSearchPackage() {
    //   // this.fnGetPackageList()

    //   const data = await getPackageListApi(this.searchParams)

    //   const packageNotAttachedArr = []

    //   // packageAttachedIds - packageGroupAttachedIds: Arrays (map from props' arrays) -> For checking if package is attached or not
    //   const packageAttachedIds = this.packageAttached.map(
    //     item => item.package_id
    //   )
    //   const packageGroupAttachedIds = this.packageGroupAttached.map(
    //     item => item.package_id
    //   )

    //   data.data.forEach(item => {
    //     if (
    //       (item.is_package_group &&
    //         !packageGroupAttachedIds.includes(item.package_id)) ||
    //       (!item.is_package_group &&
    //         !packageAttachedIds.includes(item.package_id))
    //     ) {
    //       packageNotAttachedArr.push(item)
    //     }
    //   })

    //   this.notAttachedPackageRows = this.fnGetFlatRowArray(
    //     packageNotAttachedArr
    //   )
    //   this.attachedPackageRows = [...this.attachedPackageRowsPrevious] // Reset attached rows
    // },

    /** fnSearchPackage - v2 */
    async fnSearchPackage() {
      this.attachPackageData()
    },

    fnPrepareGrid() {
      this.defaultColDef = {
        flex: 1,
        minWidth: 150,
        resizable: false
      }
      // this.getRowHeight = params => 70

      this.autoGroupColumnDef = {
        headerName: this.$t('grid.column.packageCodeOrPackageGroupCode'),
        headerCheckboxSelection: true,
        sort: 'asc',
        cellRendererParams: {
          // suppressCount: true,
          checkbox: params => {
            return params.node.level === 0
          },
          innerRenderer: params => {
            return params.data.package_code
          }
        }
      }

      this.getDataPath = data => {
        return data.path
      }

      this.groupDefaultExpanded = -1

      this.isRowSelectable = node => {
        return true
        // return node.data.is_package_group || !node.data.p_id
        // return node.level === 0
      }
    },

    /** SELECT PACKAGES */
    fnAttachPackage() {
      const nodeSelected = this.gridNotAttachedApi.getSelectedNodes()
      const rowsSelected = this.gridNotAttachedApi.getSelectedRows()
      const rowData = []

      /** Approach: Compare by Reference */
      // Select only parent Node
      nodeSelected.forEach(nodeItemSelected => {
        this.attachedPackageRows.push(nodeItemSelected.data)
        rowData.push(nodeItemSelected.data)
      })
      // this.gridAttachedApi.applyTransaction({
      //   add: rowData
      // })
      // this.gridNotAttachedApi.applyTransaction({
      //   remove: rowData
      // })
      this.notAttachedPackageRows = this.notAttachedPackageRows.filter(
        item => !rowsSelected.includes(item)
      )
    },

    /** DESELECT PACKAGES */
    fnDeattachPackage() {
      const nodeSelected = this.gridAttachedApi.getSelectedNodes()
      const rowsSelected = this.gridAttachedApi.getSelectedRows()
      const rowsDelete = []

      /** Approach: Compare by Reference */
      // Select only parent Node
      nodeSelected.forEach(nodeItemSelected => {
        this.notAttachedPackageRows.push(nodeItemSelected.data)
        rowsDelete.push(nodeItemSelected.data)
      })
      this.gridAttachedApi.applyTransaction({
        remove: rowsDelete
      })
      this.attachedPackageRows = this.attachedPackageRows.filter(
        item => !rowsSelected.includes(item)
      )
    },

    // Execute after search, or when packageGroupAttached and packageAttached change
    async attachPackage() {
      const packageAttachedIds = this.packageAttached.map(
        item => item.package_id
      )
      const packageGroupAttachedIds = this.packageGroupAttached.map(
        item => item.package_group_id
      )

      const packageRowsDelete = []

      this.gridNotAttachedApi.forEachNode(node => {
        if (node.data.is_package_group) {
          if (!packageAttachedIds.includes(node.data.is_package_group)) return
        } else {
          if (
            !node.data.p_id &&
            !packageAttachedIds.includes(node.data.package_id)
          ) {
            return
          } else if (
            node.data.p_id &&
            !packageGroupAttachedIds.includes(node.data.p_id)
          ) {
            return
          }
        }

        packageRowsDelete.push(node.data)
      })
    }
  }
}
</script>

<style scoped></style>

<style lang="scss" scoped>
.grid-container {
  border: 1px solid #dedfe7;
  border-radius: 5px;
  padding: 15px 20px;

  hr {
    border-top: 1px solid #dedfe7;
  }
}

.grid-title {
  font-weight: 700;
  color: #357456;
  text-transform: uppercase;
  margin: 10px 0;
}
.btn {
  &.only-icon.transfer {
    background: #357456;
    border-radius: 5px;
    i {
      color: #fff;
    }
  }
}
</style>
